type FlourishData = {
	src: string;
	alt: string;
	width: number;
	height: number;
};

export const flourishes = {
	kettle: { src: "kettle.png", alt: "", width: 105, height: 105 } as FlourishData,
	bulb: { src: "light-bulb.png", alt: "", width: 100, height: 100 } as FlourishData,
	windmill: { src: "windmill.png", alt: "", width: 100, height: 100 } as FlourishData,
	hat: { src: "hard-hat.png", alt: "", width: 100, height: 100 } as FlourishData,
	oven: { src: "oven.png", alt: "", width: 100, height: 100 } as FlourishData,
};

export type Flourish = keyof typeof flourishes;
